import { type FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';

import { type RootState } from '@editor2/reducers/root';
import { updatePage } from '@editor2/reducers/editor/editorSlice';
import { pageSettings } from '@editor2/containers/PageElementsPage/styles';
import { type Page } from '@editor2/types/page';

interface Props {
	courseId: number;
	page: Page;
}

const PageSettings: FC<Props> = (props) => {
	const { courseId, page } = props;

	const dispatch = useDispatch();

	const [pageType, setPageType] = useState(page.page_type);

	const { page_types } = useSelector((state: RootState) => state.courses[courseId].config);

	useEffect(() => {
		setPageType(page.page_type);
	}, [page.page_type]);

	const onPageTypeChange = (pageType: string) => {
		setPageType(pageType);
		dispatch(updatePage({ pageId: page.family_id, courseId, page_type: pageType }));
	};

	return (
		<Form className={pageSettings}>
			<Form.Group>
				<Form.Label>Page type</Form.Label>
				<Form.Control
					as="select"
					className="pageTypeSelect"
					value={pageType}
					onChange={(e) => onPageTypeChange(e.target.value)}>
					{!page_types[pageType]?.enabled && <option key={pageType} value={''}></option>}

					{Object.keys(page_types).map(
						(type) =>
							page_types[type].enabled && (
								<option key={type} value={type}>
									{page_types[type].human_name}
								</option>
							)
					)}
				</Form.Control>
			</Form.Group>
		</Form>
	);
};

export default PageSettings;
